import {createSelector} from 'reselect';
import props from '../props';

export default createSelector(
    props.user.bets_amount,
    props.user.buttons.spin,
    (bets_amount, spin_button) => {
        return {
            bets_amount,
            spin_button
        }
    }
)